<template>
  <div id="app">
    <emd-header v-if="!maintenance"></emd-header>
    <emd-breadcrumb v-if="!maintenance"></emd-breadcrumb>
    <router-view/>
    <emd-footer v-if="!maintenance"></emd-footer>
  </div>
</template>
<script>
import Header from '@/components/emerald/EmdHeader.vue'
import Breadcrumb from '@/components/emerald/EmdBreadcrumb.vue'
import EmdExternalFooter from '@/components/emerald/EmdExternalFooter.vue'

export default {
  name: 'App',
  components: {
    EmdHeader: Header,
    EmdBreadcrumb: Breadcrumb,
    EmdFooter: EmdExternalFooter
  },
  computed: {
    appVersion () {
      return this.$store.state.appVersion
    },
    maintenance () {
      return this.$store.state.maintenance
    }
  },
  mounted () {
    const meta = document.createElement('meta')
    meta.name = 'version'
    meta.content = this.appVersion
    document.getElementsByTagName('head')[0].appendChild(meta)
  }
}
</script>
<style>
.emd-btn {
  position: relative;
}
.emd-btn._state_loading{
  background-color: #cccccc;
  border-color: #cccccc;
  pointer-events: none;
}
.emd-btn._state_loading:before {
  animation: spin 2s linear infinite;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #00b7b4;
  content: '';
  height: 20px;
  left: calc(50% - 10px);
  position: absolute;
  width: 20px;
  z-index: 2;
}
.emd-btn._state_loading:after {
  background-color: #cccccc;
  border-color: #cccccc;
  content: '';
  display: block;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
}
@keyframes spin {
  0% {
    transform: rotate(0deg)
  }
  100% {
    transform: rotate(360deg)
  }
}

@keyframes opacity {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
.emd-alert.hideFeedback {
  display: none;
  opacity: 0;
  visibility: hidden;
  transition: .1s ease-in .1s;
}
.emd-alert.displayFeedback {
  display: block;
  opacity: 1;
  visibility: visible;
  transition: .1s ease-in .1s;
}
</style>
